import * as ActiveJS from "../exports";
import {Observer} from "./observer";
import {Reactivity} from "./reactivity";
import {SFV} from "./single-file-view";
import {SFV_Support} from "../support/singleFileView";

export const Features = {

    VM: {},
    LifeCycles: {},
    Observers: {},
    exposeInitialRun: true,

    /**
     *
     */
    setup: () => {
        window.Import = Features.Import;
        window.Expose = Features.Expose;
        // window.Def = Features.Def;
        // window.Reactive = Features.Reactive;
        // window.Observe = Features.Observe;
        // window.onMounted = Features.onMounted;
        // window.onRendered = Features.onRendered;
        // window.onDestroyed = Features.onDestroyed;
        // window.Prop = Features.Prop;
        // window.pageNotFound = Features.pageNotFound;
        // window.newController = SFV_Support.newController;
    },

    /**
     * Defines a reactive property on the controller
     * @param {Object} value
     * @returns {{value: *, isDef: Boolean}}
     */
    Def: (value) => {
        const _Object = {value: value, isDef: true};
        return Observer.Observe(_Object);
    },

    /**
     * Defines a reactive object on the controller
     * @param {Object} value
     * @returns {Object}
     */
    Reactive: (value) => {
        const checkForNested = (data) => {
            for (const valueKey in data) {
                if (!(Array.isArray(data[valueKey])) && (typeof data[valueKey] === 'object')) {
                    data[valueKey] = Observer.Observe(data[valueKey]);
                    checkForNested(data[valueKey]);
                }
            }
        };

        checkForNested(value);
        const _Object = {...value, isRct: true};
        return Observer.Observe(_Object);
    },

    /**
     * Allows for watching a reactive properties for change
     * @param {String} property
     * @param {Function} callback
     */
    Observe: (property, callback) => {
        Features.Observers[property] = callback;
    },

    /**
     * Will reveal the data you have setup to the controller
     * @param {String} viewWrapperId
     * @param {Object} data
     */
    Expose: async (viewWrapperId, data) => {
        // let the compiler know this is the initial run
        Features.exposeInitialRun = true;

        // reset the DOM Bindings
        $ActiveJS.DOMBindings = [];
        $ActiveJS.DOMBoundKeys = [];
        $ActiveJS.DOMAnimations = [];

        // check for Defined props
        for (const key in data) {
            // if property was created using Def(), store real property name
            if (data[key].isDef) {
                data[key]["name"] = key;
            }
        }

        // setup the VM data
        Features.VM = {
            viewWrapperId,
            ...data
        };

        // setup global view variable
        window.$this = Features.VM;

        // mounted callback for views
        if (Features.LifeCycles["Mounted"]) {
            Features.LifeCycles["Mounted"]();
            Features.LifeCycles["Mounted"] = false;
        }

        // start the render process
        await SFV.startRenderProcess();

        // tell system that expose is done running
        Features.exposeInitialRun = false;
    },

    /**
     * Life cycle method which is called when the controller in mounted to the view
     * @param {Function} callback
     * @constructor
     */
    onMounted: (callback) => Features.LifeCycles["Mounted"] = callback,

    /**
     * Life cycle method which is called when the view template has been rendered
     * @param {Function} callback
     * @constructor
     */
    onRendered: (callback) => Features.LifeCycles["Rendered"] = callback,

    /**
     * Life cycle method which is called when you route to another view
     * @param {Function} callback
     * @constructor
     */
    onDestroyed: (callback) => Features.LifeCycles["Destroyed"] = callback,

    /**
     * Will import an export of ActiveJS or a loaded custom library
     * @param {"@ActiveJS" || "@Library" || "@Animations"} path
     * @returns {{
     *      Animations: Object
     *      Def: Object,
     *      Observe: Object,
     *      Prop: Object,
     *      Reactive: Object,
     *      Router: Object,
     *      State: Object,
     *      createApp: Function,
     *      newController: Function,
     *      onDestroyed: Function,
     *      onMounted: Function,
     *      onRendered: Function,
     *      pageNotFound:Function } || *}
     * @constructor
     */
    Import: (path) => {
        const rawPath = path.split('/');
        const parsedPath = rawPath[rawPath.length - 1];

        if (path.indexOf('@ActiveJS') > -1) {
            // need to look for a loaded library
            if (parsedPath !== "@ActiveJS") {
                if (ActiveJS[parsedPath]) return ActiveJS[parsedPath];
            }
            else {
                return ActiveJS;
            }
        }
        else if (path.indexOf('@Library') > -1) {
            // need to look for a loaded library
            if (parsedPath !== "@Library") {
                if ($ActiveJS['Libraries'][parsedPath]) return $ActiveJS['Libraries'][parsedPath];
            }
            else {
                return $ActiveJS['Libraries'];
            }
        }
        else if (path.indexOf('@Animations') > -1) {
            if (ActiveJS['Animations'][parsedPath]) return ActiveJS['Animations'][parsedPath];
        }
        else {
            // todo : handle error
            console.error(`SyntaxError at Import("${path}") :: Please make sure you use the [@ActiveJS/] or [@Library/] or [@Animations/] prefix in your import url`)
        }
    },

    /**
     * Gets the value of a prop passed to a view/component
     * @param {String | Boolean} name
     * @constructor
     */
    Prop: (name=false) => {

        if (name) {
            if ($ActiveJS.PassedProps[name] !== undefined) return $ActiveJS.PassedProps[name];
            else {
                console.error(`Undefined Prop (${name}) :: The prop you are trying to access was not passed to this view`)
            }
        }
        else {
            return $ActiveJS.PassedProps;
        }
    },
    
    /*
     * Will define a default 404 page for the application
     * @param url
     */
    pageNotFound: (url) => $ActiveJS.pageNotFound = url,

};